/*
 * Genovare V2 category page.
 * The server sends up to 250 products (all of them today): the first 12 as tiles in the grid, the rest inert in a
 * <template data-gv-rest> so their images and layout cost nothing until needed. This script fetches any further pages
 * (a collection can hold more than 250), builds the research-area chips from all the products, filters on the page
 * with no reload, shows 12 tiles at a time (moving waiting tiles into the grid, in order, only when they are shown),
 * and keeps the "Showing ..." line up to date.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-gv-cat]');
  if (!root) return;

  var grid = root.querySelector('[data-gv-grid]');
  var chipsBox = root.querySelector('[data-gv-chips]');
  var countEl = root.querySelector('[data-gv-count]');
  var moreBtn = root.querySelector('[data-gv-more]');
  var moreLabel = root.querySelector('[data-gv-more-label]');
  var step = parseInt(root.getAttribute('data-step'), 10) || 12;
  var noun = root.getAttribute('data-noun') || 'compounds';
  var pages = parseInt(root.getAttribute('data-pages'), 10) || 1;
  var words = {
    showing: root.getAttribute('data-showing') || 'Showing',
    of: root.getAttribute('data-of') || 'of',
    inn: root.getAttribute('data-in') || 'in',
    all: root.getAttribute('data-all') || 'All',
    more: root.getAttribute('data-more') || 'Show more',
  };
  var state = { area: '', visible: step };
  var urlArea = '';
  try { urlArea = new URL(window.location.href).searchParams.get('area') || ''; } catch (e) {}
  var items = [];

  var slice = Array.prototype.slice;

  function fromTemplate(scope) {
    var t = scope.querySelector('template[data-gv-rest]');
    return t ? slice.call(t.content.children) : [];
  }

  function collect(extra) {
    if (!items.length) items = slice.call(grid.children).concat(fromTemplate(root));
    if (extra) items = items.concat(extra);
  }

  // Waiting tiles join the grid only when shown; the grid keeps the collection's order.
  function attach(list) {
    var added = false;
    list.forEach(function (li) {
      if (!li.parentNode || li.parentNode !== grid) added = true;
    });
    if (!added) return;
    items.forEach(function (li) {
      if (li.parentNode === grid || list.indexOf(li) !== -1) grid.appendChild(li);
    });
  }

  function matching() {
    return items.filter(function (li) {
      return !state.area || li.getAttribute('data-area') === state.area;
    });
  }

  function render() {
    var list = matching();
    var shown = Math.min(state.visible, list.length);
    attach(list.slice(0, shown));
    items.forEach(function (li) {
      li.hidden = true;
    });
    list.forEach(function (li, i) {
      li.hidden = i >= shown;
    });
    if (moreBtn) moreBtn.hidden = shown >= list.length;
    if (moreLabel) moreLabel.textContent = words.more;
    if (countEl) {
      if (state.area) {
        var areaText = state.area.toLowerCase();
        countEl.textContent =
          shown < list.length
            ? words.showing + ' ' + shown + ' ' + words.of + ' ' + list.length + ' ' + words.inn + ' ' + areaText
            : words.showing + ' ' + list.length + ' ' + words.inn + ' ' + areaText;
      } else {
        countEl.textContent = words.showing + ' ' + shown + ' ' + words.of + ' ' + list.length + ' ' + noun;
      }
    }
    syncUrl();
    if (chipsBox) {
      Array.prototype.forEach.call(chipsBox.querySelectorAll('button'), function (b) {
        b.setAttribute('aria-pressed', (b.getAttribute('data-area') || '') === state.area ? 'true' : 'false');
      });
    }
  }

  // The chosen research area stays in the address bar, and the format switcher links carry it to the other format.
  function syncUrl() {
    try {
      var here = new URL(window.location.href);
      if (state.area) here.searchParams.set('area', state.area); else here.searchParams.delete('area');
      window.history.replaceState(null, '', here.toString());
      Array.prototype.forEach.call(document.querySelectorAll('.gv-cat-formats__list a[href]'), function (a) {
        var link = new URL(a.getAttribute('href'), window.location.href);
        if (state.area) link.searchParams.set('area', state.area); else link.searchParams.delete('area');
        a.setAttribute('href', link.pathname + link.search + link.hash);
      });
    } catch (e) {}
  }

  // /collections/peptide-pens?area=Metabolic opens with that research area already chosen (if this collection has it).
  function applyUrlArea() {
    if (!urlArea) return;
    var found = items.some(function (li) { return li.getAttribute('data-area') === urlArea; });
    state.area = found ? urlArea : '';
  }

  function buildChips() {
    if (!chipsBox) return;
    var counts = {};
    items.forEach(function (li) {
      var a = li.getAttribute('data-area');
      if (a) counts[a] = (counts[a] || 0) + 1;
    });
    var areas = Object.keys(counts).sort(function (a, b) {
      return counts[b] - counts[a] || a.localeCompare(b);
    });
    // One area (or none): nothing to filter, so the chip row stays out and only the count remains.
    if (areas.length < 2) return;
    chipsBox.innerHTML = '';
    [''].concat(areas).forEach(function (area) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gv-fchip';
      b.setAttribute('data-area', area);
      b.setAttribute('aria-pressed', 'false');
      b.textContent = area || words.all;
      b.addEventListener('click', function () {
        urlArea = '';
        state.area = area;
        state.visible = step;
        render();
      });
      chipsBox.appendChild(b);
    });
    chipsBox.hidden = false;
  }

  function loadMorePages() {
    if (pages < 2) return Promise.resolve();
    var jobs = [];
    for (var p = 2; p <= pages; p++) {
      (function (page) {
        var url = new URL(window.location.href);
        url.searchParams.set('page', String(page));
        jobs.push(
          fetch(url.toString(), { credentials: 'same-origin' })
            .then(function (r) {
              return r.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              return slice.call(doc.querySelectorAll('[data-gv-grid] > li')).concat(fromTemplate(doc)).map(function (li) {
                return document.importNode(li, true);
              });
            })
            .catch(function () {
              return [];
            })
        );
      })(p);
    }
    return Promise.all(jobs).then(function (lists) {
      lists.forEach(function (list) {
        collect(list);
      });
    });
  }

  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      state.visible += step;
      render();
    });
  }

  collect();
  applyUrlArea();
  render();
  loadMorePages().then(function () {
    applyUrlArea();
    buildChips();
    render();
  });
})();
